import AdminService from "external-services/diary-admin-service/admin.service";
import OAuth2Service from 'external-services/oauth-login/OAuth2.service';

const NS = 'AdminLoginCtrl';

export default function AdminLoginCtrl(AuthService) {
  "ngInject";

  var venue = AdminService.getVenue();
  if (venue && venue.accountId) {
    if (window.config.enableOAuth2 && OAuth2Service.getIsEnableOAuth()) {
      const link = window.config.adminUrl + 'oauth2-support-login:' + venue.accountId + ':' + venue.id;
      window.open(link, '_self'); //
    } else {
      AuthService.checkAuth();
      AuthService.getAuthorizationCode().then(function (authCode) {
        var link = window.config.adminUrl + 'support-login:' + venue.accountId + ':' + venue.id + ':' + authCode;
        window.open(link, '_self'); //
      });
    }
  } else {
    window.open(`${window.config.adminUrl}/login`, '_self');
  }
}
